export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

type LeadResponse = { accepted: boolean; message?: string };

interface PricingLead {
  fullName: string;
  email: string;
  phone: string;
  message: string;
}

const getHubspotToken = (): string | undefined => {
  const match = document.cookie.match(/(?:^|; )hubspotutk=([^;]*)/);

  return match ? decodeURIComponent(match[1]) : undefined;
};

export const submitPricingLead = async ({ fullName, email, phone, message }: PricingLead): Promise<string | undefined> => {
  const [firstname, ...rest] = fullName.trim().split(/\s+/);
  const lastname = rest.join(' ');

  let response: Response;

  try {
    response = await fetch('/api/lead', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        fields: [
          { name: 'firstname', value: firstname },
          { name: 'lastname', value: lastname || firstname },
          { name: 'email', value: email.trim() },
          { name: 'phone', value: phone.trim() },
          { name: 'message', value: message },
        ],
        context: {
          pageName: 'Global Database Pricing',
          pageUri: window.location.href,
          hutk: getHubspotToken(),
        },
      }),
    });
  } catch {
    return 'Could not reach the server. Please check your connection and try again.';
  }

  const result = (await response.json().catch(() => ({}))) as LeadResponse;

  if (!response.ok || !result.accepted) {
    return result.message || 'Something went wrong. Please try again.';
  }

  return undefined;
};
